export default "__VITE_ASSET__DACK3JuX__"